import styled from "styled-components";
import {Dialog as MuiDialog} from "@mui/material";
import {colors, sizes, fontSize} from "../../../../themes";

export const LoginWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  font-style: normal;
  font-weight: 400;
  font-size: 17px;
  line-height: 140%;
  color: ${colors.text.ebony};
  .login-to-pickapier {
    font-weight: 700;
    color: ${colors.text.kleinBlue};
    cursor: pointer;
    :hover {
      text-decoration: underline;
    }
  }
  .welcome-boater {
    font-weight: 700;
    color: ${colors.text.ebony};
  }
  @media only screen and ${sizes.max991} {
    font-size: 2.6vw;  
    img {
      width: 3.8vw;
    }
  }
`;

export const Dialog = styled(MuiDialog)`
  && {
    .MuiDialogContent-root {
      background-color: #FFFFFF;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
      border-radius: 8px;
      padding: 52px 125px 40px 111px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      gap: 7px;
      @media only screen and ${sizes.max991} {
        padding: 10vw 10vw 10vw 10vw;
        gap: 1.4vw;
      }
    }
  }
`;

export const DialogTitle = styled.span`
  font-style: normal;
  font-weight: 400;
  ${fontSize(24)}
  line-height: 120%;
  color: ${colors.text.kleinBlue};
`;

export const DialogSubtitle = styled.span`
  font-style: normal;
  font-weight: 400;
  ${fontSize(14)}
  line-height: 120%;
  color: ${colors.text.ebony};
  >a {
    text-decoration: none;
    font-weight: 700;
    color: ${colors.text.kleinBlue};
  }
`;

export const LoginForm = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const LoginFormInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #E6E6E6;
  height: 47px;
  padding: 6px 20px;
  color: #2C2C2C;
  ${fontSize(14)}
  line-height: 200%;
  border-radius: 3px;
  margin-bottom: ${props => props.pad ? 24 : 0}px;
  &::placeholder {
    color: #777777;
  }
  @media only screen and ${sizes.max991} {
    margin-bottom: ${props => props.pad ? 4.8 : 0}vw;
  }
`;

export const ErrorMessage = styled.span`
  clear: both;
  min-height: 24px;
  color: rgba(0, 0, 0, 0.45);
  ${fontSize(14)}
  line-height: 1.5715;
  -webkit-transition: color 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
  transition: color 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
  box-sizing: border-box;
  margin: 5px 0 10px;
  color: #ff4d4f;
  @media only screen and ${sizes.max991} {
    margin: 1vw 0 2vw;
  }
`;

export const LoginButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border: 0;
  background-color: #194AB9;
  border-radius: 3px;
  height: 47px;
  width: 100%;
  ${fontSize(17)}
  font-weight: 700;
  color: white;
  text-shadow: 0 -1px 0 rgb(0 0 0 / 12%);
  box-shadow: 0 2px 0 rgb(0 0 0 / 5%);
  line-height: 1.5715;
  cursor: pointer;
  svg {
    fill: white;
  }
`;

export const Divider = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  margin: 16px 0;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  font-size: 16px;
  white-space: nowrap;
  text-align: center;
  border-top: 0;
  border-top-color: rgba(0, 0, 0, 0.06);
  span {
    font-size: 15px;
    font-weight: 700;
    color: #777777;
    padding: 0 1em;
  }
  :before {
    position: relative;
    top: 50%;
    width: 50%;
    border-top: 1px solid transparent;
    border-top-color: inherit;
    border-bottom: 0;
    transform: translateY(50%);
    content: '';
  }
  :after {
    position: relative;
    top: 50%;
    width: 50%;
    border-top: 1px solid transparent;
    border-top-color: inherit;
    border-bottom: 0;
    transform: translateY(50%);
    content: '';
  }
`;

export const AuthButtons = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const GoogleButton = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  ${fontSize(15)}
  font-weight: 700;
  width: 100%;
  height: 47px;
  margin-bottom: 16px;
  background-color: white;
  color: black;
  border: 1.5px solid #bfbfbf;
  border-radius: 2px;
  box-shadow: none;
  cursor: pointer;
`;

export const FacebookButton = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  ${fontSize(15)}
  width: 100%;
  height: 47px;
  margin-bottom: 16px;
  border-radius: 2px;
  box-shadow: none;
  cursor: pointer;
  border-color: ${colors.background.chambray};
  background-color: ${colors.background.chambray};
  font-weight: bold;
  color: white;
`;

export const Badge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${colors.background.malibu};
  font-style: normal;
  font-weight: 700;
  ${fontSize(17)}
  line-height: 140%;
  color: ${colors.general.white};
  margin-right: 10px;
  @media only screen and ${sizes.max991} {
    width: 8vw;
    height: 8vw;
  }
`;

export const WelcomeMessage = styled.span`
  font-style: normal;
  font-weight: 700;
  ${fontSize(17)}
  line-height: 140%;
  color: ${colors.text.ebony};
`;

export const CloseIcon = styled.img`
  width: 24px;
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 25px;
`;

export const ForgotPassword = styled.span`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  ${fontSize(12)}
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #323232;
  padding-top: 5px;
`;
